import { render, staticRenderFns } from "./ProductIntroduction.vue?vue&type=template&id=0ce6630f&scoped=true&"
import script from "./ProductIntroduction.vue?vue&type=script&lang=js&"
export * from "./ProductIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./ProductIntroduction.vue?vue&type=style&index=0&id=0ce6630f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce6630f",
  null
  
)

export default component.exports